export default __webpack_public_path__ + "static/media/2.a42b7e7e.png";